module.exports = __webpack_public_path__ + "resources/img/logo_nhn_cloud.7c5f8584376c895c608ee0d8279e7744.svg";